import React, { useState } from "react";
import InfoCardAccordion from "./InfoCardAccordian";
import {
  useToast,
  Text,
  Box,
  Button,
  Center,
  Flex,
  Spacer
} from "@chakra-ui/react";
import { Divider } from "antd";
import { useVoiceprintStore } from "../store";
import { BASE_URL } from "../constants/api";
import axios from "axios";

function EnrollmentInfo({
  phoneNumber,
  speechDuration,
  setProgress,
  accessToken,
  refetch
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [deleteIsLoading, setDeleteIsLoading] = useState(false);
  const [newVpIsLoading, setNewVpIsLoading] = useState(false);
  const [buttonInterval, setButtonInterval] = useState(40);

  const toast = useToast();

  const {
    setCurrentStep,
    stream_uid,
    currentStep,
    name,
    setName,
    setStreamId,
    setExternalId,
    setSpeechDuration
  } = useVoiceprintStore();

  let buttonCounter = 0;
  const deleteVoiceprint = setIsLoading => {
    setIsLoading(true);
    axios
      .delete(
        `${BASE_URL}/voice/delete`,
        {
          data: {
            external_uid: phoneNumber
          }
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        }
      )
      .then(res => {
        if (res.status === 200) {
          toast({
            title: "Successfully Deleted Voiceprint",
            status: "success",
            duration: 2000,
            isClosable: true
          });

          setIsLoading(false);
          setCurrentStep("new");

          refetch();

          setName(null);
          setStreamId(null);
          setExternalId(null);
          setSpeechDuration("0");
        }
      })
      .catch(err => {
        setIsLoading(false);
        console.error("End Call Error: ", err);
      });
  };

  const handleDelete = e => {
    deleteVoiceprint(setDeleteIsLoading);
  };

  const handleVerify = e => {
    console.log("verify");
    setProgress(0);
    setIsLoading(true);
    setExternalId(phoneNumber);


    toast({
      title: "Initiating Verification Call",
      description:
        "Please wait while we initiate a call to your number for verification purposes.",
      status: "loading",
      duration: 5000,
      isClosable: true
    });

    axios
      .post(
        `${BASE_URL}/initiate_call/verify`,
        { external_id: phoneNumber, name: " " },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        }
      )
      .then(res => {
        if (res.status === 200) {
          // Verify voice print => 5 seconds

          let call_interval = null;
          let counter = 0;

          let button_interval = null;

          if (!button_interval) {
            button_interval = setInterval(() => {
              buttonCounter += 1000;
              console.log("buttonCounter------------------>", buttonCounter);
              setButtonInterval(prev => prev - 1);
              if (buttonCounter >= 40000) {
                buttonCounter = 0;
                clearInterval(button_interval);
                button_interval = null;
                setButtonInterval(40);
                setIsLoading(false);
              }
            }, 1000);
          }

          if (!call_interval) {
            call_interval = setInterval(() => {
              counter += 3000;

              console.log("counter------------------>", counter);

              if (counter >= 40000) {
                toast({
                  title: "Trying Again.",
                  description:
                    "It seems like you did not receive or attend the call. Let's try that again",
                  status: "info",
                  duration: 3000,
                  isClosable: true
                });

                counter = 0;
                clearInterval(call_interval);
                call_interval = null;
                handleVerify();
                // return;
              }

              axios
                .get(
                  `${BASE_URL}/check_call_status?external_uid=${phoneNumber}`,
                  {
                    headers: {
                      Authorization: `Bearer ${accessToken}`
                    }
                  }
                )
                .then(res2 => {
                  if (res2.status === 200 && res2.data.active === true) {
                    console.log(res2.data);

                    toast({
                      title: "Call Initiated",
                      status: "success",
                      duration: 2000,
                      isClosable: true
                    });

                    setIsLoading(false);
                    setStreamId(res2.data.stream_uid);
                    setCurrentStep("verify"); // Here we go to next step
                    clearInterval(call_interval);
                  }
                })
                .catch(err => {
                  setIsLoading(false);
                  console.error(err);
                });
            }, 3000);
          }
        } else {
          setIsLoading(false);
          console.error(res);
        }
      })
      .catch(err => console.error(err));
  };
  return (
    <Box
      w="100%"
      borderWidth="1px"
      borderColor="#969696"
      borderRadius="md"
      mb="2%"
    >
      <InfoCardAccordion title={phoneNumber} bg="#ffffff">
        <Box p="1%">
          <Flex mt="2%">
            <Text fontSize="sm" color="#515151">
              Phone Number
            </Text>
            <Spacer />
            <Text fontSize="sm" color="#515151">
              {phoneNumber}
            </Text>
          </Flex>
          <Flex mt="2%">
            <Text fontSize="sm" color="#515151">
              Speech Duration
            </Text>
            <Spacer />
            <Text fontSize="sm" color="#515151">
              {speechDuration}s
            </Text>
          </Flex>
          <Divider color="#1b1c1e" />
          <Text fontSize="sm" color="#515151" mb="1%">
            Click the VERIFY button to verify your voice based on your
            previously created voiceprint.
          </Text>
          <Flex
            justifyContent="flex-end"
            alignItems="flex-end"
            flexDir="row"
            pt={3}
            wrap="wrap"
          >
            <Button
              bg="#ffffff"
              w="20%"
              size="sm"
              m={2}
              borderWidth={2}
              borderRadius="2xl"
              onClick={handleDelete}
              isLoading={deleteIsLoading}
            >
              <Text color="#1b1c1e">Delete</Text>
            </Button>
            {isLoading === false ? (
              <Button
                m={2}
                size="sm"
                mr={6}
                bg="#1b1c1e"
                w="20%"
                borderRadius="2xl"
                onClick={handleVerify}
                isLoading={isLoading}
              >
                <Text color="#ffffff">Verify</Text>
              </Button>
            ) : (
              <Button
                m={2}
                size="sm"
                mr={6}
                bg="#1b1c1e"
                w="40%"
                borderRadius="2xl"
                disabled
              >
                <Text color="#ffffff" fontSize="xs">
                  Trying again in {buttonInterval} seconds
                </Text>
              </Button>
            )}
          </Flex>
        </Box>
      </InfoCardAccordion>
    </Box>
  );
}

export default EnrollmentInfo;
